'use strict';

var svaneTvis = svaneTvis || {};
var novicell = novicell || {};
var setCookie = setCookie || function(){};

svaneTvis.languagePopup = svaneTvis.languagePopup || new function () {
    this.init = function () {
        var browserLanguage = window.navigator.language;
        var siteLanguage = document.documentElement.lang.toLowerCase();
        var languageOverlayShownCookie = readCookie('languageOverlayShown');
        var languageOverlayHolder = document.getElementById('languageOverlayHolder');
        if(languageOverlayHolder && languageOverlayShownCookie === undefined && siteLanguage !== 'no' && (browserLanguage === 'no' || browserLanguage === 'nb' || browserLanguage === 'nn')){
            novicell.overlay.create({
                'selector':'#languageOverlayHolder',
                'class': 'novi-overlay--language-overlay',
                'onLoaded': function(){
                    var backdrop = document.getElementById('js-novi-backdrop');
                    backdrop.classList.add('novi-backdrop--language-overlay');
                    var stayLink = backdrop.querySelector('.language-overlay__link');
                    if(stayLink) {
                        stayLink.addEventListener('click', function(e) {
                            e.preventDefault();
                            var closeBtn = document.getElementById('js-novi-overlay-close');
                            if(closeBtn) {
                                closeBtn.click();
                            }
                        });
                    }
                }
            });
            setCookie('languageOverlayShown', 'true', 1);
        }
    };
}();

var readCookie = function (name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) {
        return parts.pop().split(";").shift();
    } 
};
